import { gEnums } from "global/enums/globalEnums"
import { useContext, useMemo } from "react"
import { ParentContext } from "../ParentContext"
import { useAppUserAccess } from "./useAppUserAccess"
import { useAllowAppAdmin } from "./useAllowAppAdmin"
import { FrameworkContext } from "../FrameworkContent"
import { filterHelpers } from "global/common/filtering"
import { sortObject } from "global/common/sorting"
import { useAllowAdmin } from "./useAllowAdmin"
import { useAllowItemsMain } from "./useAllowItemsMain"
import { useAllowAppUser } from "./useAllowAppUser"
import { useAllowTicketing } from "./useAllowTicketing"

export const usePermissionGroups = () => {

  const pageIcons = null

  const parentContext = useContext(ParentContext)
  const { states, fns } = parentContext ?? {}
  const { paps_state, page_state, currentSettings_state } = states
  const { pathViews } = paps_state
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { viewItems } = aps_page ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { desktopMode } = framework_state ?? {}

  const _defaultAdminLevels = {
    adminOnly: gEnums.accessLevels.admin.value,
    appAdminOnly: gEnums.accessLevels.appDataAdmin.value,
  }

  const appUserAccess = useAppUserAccess()

  const { appUser_fns } = fns

  const { aps_global, aps_styles, aps_views } = _.get(currentSettings_state, 'gvviSettings', {});
  const { events: aps_events, clients: aps_clients } = aps_views ?? {}

  const aps_current = pathViews.events ? aps_events : aps_clients

  const defaultSnC = aps_styles ? aps_styles[gEnums.projectStyles.gridIcons] : {}
  let { viewItems: viewItems_page } = aps_current ?? {}

  const { appTicketing } = aps_global ?? {}

  const { ticketingManagers, scanningManagers } = appTicketing ?? {}

  const showProp = desktopMode ? gEnums.showTypes.showDesktop : gEnums.showTypes.show
  const gcProps = { defaultSnC }

  let gpis = viewItems_page
  appUser_fns.validateAccess_items(gpis)


  gpis = !pageIcons && gpis ? filterHelpers.filterObject(gpis, showProp) : gpis
  gpis = !pageIcons && gpis ? filterHelpers.filterObject(gpis, '_viewPermissionType', [gEnums.viewPermissionTypes.allow, gEnums.viewPermissionTypes.allowToAppUserAdmin]) : gpis
  gpis = !pageIcons && gpis ? sortObject(gpis, 'position') : gpis

  let gpish = !pageIcons && viewItems_page ? _(viewItems_page)
    .pickBy(item => item?.show !== true)   // keep only show=false
    .toPairs()                               // [[key, value], ...]
    .sortBy(([key]) => key)                  // sort by key
    .fromPairs()                             // back to object
    .value() : gpis

  const _allows = {
    ao: appUserAccess && (appUserAccess.accessLevel >= _defaultAdminLevels.adminOnly),
    aao: appUserAccess && (appUserAccess.accessLevel >= _defaultAdminLevels.appAdminOnly),
    atm: false,
    ats: false,
    avt: true,
    asr: true,
    aqa: true,
    au: false,
  }

  _allows.atm = _allows.ao || appUser_fns.validateAccess_item(null, null, ticketingManagers)
  _allows.ats = _allows.ao || appUser_fns.validateAccess_item(null, null, scanningManagers)

  const allowAdmin = useAllowAdmin({ gcProps })
  const allowAppAdmin = useAllowAppAdmin({ allows: _allows })
  const allowMain = useAllowItemsMain({ gcProps, gridPageItems: gpis, hidden: false, allows: _allows })
  const allowHidden = useAllowItemsMain({ gcProps, gridPageItems: gpish, hidden: true, allows: _allows })
  const allowAppUser = useAllowAppUser({ gcProps, allows: _allows })
  const allowTicketing = useAllowTicketing({ gcProps, allows: _allows })


  const permissionGroups = useMemo(() => {
    const _permissionGroups = {
      page: allowMain,
      pageHidden: allowHidden,
      admin: allowAdmin,
      appAdmin: allowAppAdmin,
      appUser: allowAppUser,
      ticketing: allowTicketing,
      ready: true,
    }
    return _permissionGroups
  }, [viewItems, pathViews.events, pathViews.clients, appUserAccess])

  return permissionGroups

}